import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between mt-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex justify-between mt-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector = _resolveComponent("Selector")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", null, [
      _createElementVNode("article", null, [
        (_ctx.showModalAdd)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 0,
              title: "Agregar mascota",
              visible: _ctx.showModalAdd,
              "onUpdate:visible": _cache[2] || (_cache[2] = (e) => _ctx.showModalAdd = e)
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("button", {
                    class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalAdd = false))
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: _normalizeClass(["px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.savePet && _ctx.savePet(...args))),
                    disabled: !_ctx.isFieldsFilled
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Agregar"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
                  ], 10, _hoisted_2)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Selector, {
                  items: _ctx.selectedUser,
                  selectedItem: Number(_ctx.selectedItem),
                  placeHolder: 'Seleccione usuario',
                  label: 'Usuario',
                  onUpdate: _ctx.onUpdateModelUser
                }, null, 8, ["items", "selectedItem", "onUpdate"]),
                _createVNode(_component_Selector, {
                  class: "mt-4",
                  items: _ctx.animalSelect,
                  selectedItem: Number(_ctx.selectAnimal),
                  placeHolder: 'Seleccione tipo de animal',
                  label: 'Animal',
                  onUpdate: _ctx.onUpdateModelAnimal
                }, null, 8, ["items", "selectedItem", "onUpdate"])
              ]),
              _: 1
            }, 8, ["visible"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("article", null, [
        (_ctx.showModalEdit)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 0,
              title: "Editar mascota",
              visible: _ctx.showModalEdit,
              "onUpdate:visible": _cache[5] || (_cache[5] = (e) => _ctx.showModalEdit = e)
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "px-4 py-2 mr-2 rounded-lg bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalEdit = false))
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: _normalizeClass(["px-4 py-2 rounded-lg bg-primary text-white hover:bg-green-600 focus:bg-green-600", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveEditPet && _ctx.saveEditPet(...args))),
                    disabled: !_ctx.isFieldsFilled
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Editar"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                  ], 10, _hoisted_8)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Selector, {
                  items: _ctx.selectedUser,
                  selectedItem: Number(_ctx.selectedItem),
                  placeHolder: 'Seleccione usuario',
                  label: 'Usuario',
                  onUpdate: _ctx.onUpdateModelUser
                }, null, 8, ["items", "selectedItem", "onUpdate"]),
                _createVNode(_component_Selector, {
                  class: "mt-4",
                  items: _ctx.animalSelect,
                  selectedItem: Number(_ctx.selectAnimal),
                  placeHolder: 'Seleccione tipo de animal',
                  label: 'Animal',
                  onUpdate: _ctx.onUpdateModelAnimal
                }, null, 8, ["items", "selectedItem", "onUpdate"])
              ]),
              _: 1
            }, 8, ["visible"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.formattedData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_TableComponent, {
              title: 'Mascotas',
              items: _ctx.formattedData,
              columns: _ctx.columns,
              buttons: _ctx.buttons,
              showButtons: _ctx.showButtons,
              searchTableData: _ctx.searchTableData
            }, {
              "extra-header": _withCtx(() => [
                _createVNode(_component_AddButton, {
                  onClick: _ctx.addItem,
                  class: "self-end w-full flex justify-end mr-4"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["items", "columns", "buttons", "showButtons", "searchTableData"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEditAlert)
        ? (_openBlock(), _createBlock(_component_ModalAlert, {
            key: 1,
            option: true
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ModalAlert, {
        title: 'Eliminar usuario',
        message: '¿Esta seguro de eliminar este usuario?',
        visible: _ctx.showAlertModal,
        onAccept: _ctx.handleAccept,
        onCancelAlert: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAlertModal = false))
      }, null, 8, ["visible", "onAccept"])
    ])
  ]))
}